// GlobalContextProvider.js
import Cookies from 'js-cookie';
import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { v4 as uuidV4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { TranslationByPage } from 'Lang/TranslationByPage/TranslationByPage';
import useGetAccessList from 'Global/Hooks/useGetAccessList/useGetAccessList';
import { Get, Post } from 'Xhr/Xhr';
import { env } from 'env';
import useCacheLocales from 'Global/Hooks/useCacheLocales/useCacheLocales';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';

export const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  let UserInformation =
    Cookies.get('user') !== undefined &&
    JSON.parse(Cookies.get('user'));
  const AccessRoles =
    UserInformation?.AccessRole?.map((el) =>
      el.toLowerCase()
    ) ?? '';

  // console.log('AccessRoles=>', AccessRoles);

  const [IsDrawerOpen, setDrawerOpen] =
    React.useState(false);
  const [EntirePageRender, setEntirePageRender] =
    React.useState(false);
  const [MoreColumns, setMoreColumns] =
    React.useState(true);
  const [changeRender, setChangeRender] =
    React.useState(false);
  const [isTokenValid, setIsTokeValid] =
    React.useState(false);
  const [appConfig, setAppConfig] = React.useState([]);
  const [settingDrawerOpen, setSettingDrawerOpen] =
    useState(false);
  const [LangList, setLangList] = useState([]);
  const [watchLangList, setWatchLangList] = useState(false);

  const [isTurnAllowed, setIsTurnAllowed] = useState(false);

  // define your global state and any methods to update it here
  const navigate = useNavigate();
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));
  const filteredTranslation = useMemo(
    () =>
      TranslationByPage.filter(
        (obj, index, self) =>
          index ===
          self.findIndex((el) => el.FormKey === obj.FormKey)
      ),
    [TranslationByPage]
  );

  useCacheLocales(filteredTranslation, setWatchLangList);

  const lang = JSON.parse(
    localStorage.getItem('languageArray')
  );

  useMemo(() => {
    setLangList(lang);
  }, [JSON.stringify(lang), watchLangList]);
  // GetPostResponse(
  //   `${process.env.REACT_APP_API_URL_API_GET_TRANSLATION_LIST}`,
  //   false,
  //   {
  //     list: filteredTranslation,
  //     AddLang: process.env.REACT_APP_ADD_LANGUAGE,
  //   }
  // )?.Data?.list;
  const roles = useGetAccessList(isTokenValid);

  // console.log('roles rolesroles===>', roles);

  const paths = [
    ...new Set(roles?.map((el) => el.FldRootPath)),
  ].filter((el) => el !== null && el.length > 0);

  // console.log('paths are =>', paths);

  // console.log('paths are =>', paths);

  // console.log('pathspaths------>', paths);

  const rootPaths = [
    ...paths,
    ...(paths.includes('/PatientsForVisit')
      ? ['/PatientsForVisitPreview']
      : []),
    // '/main',
    // '/adv',
    // '/main/adv',
    // '/messages',
    // '/main/messages',
    // '/main/about',
    // '/main/pacsImages',
    // '/about',
    // '/pacsImages',
    // '/ContactUs',
    // '/main/ContactUs',
    // '/main/CompleteProfileUser',
    // '/CompleteProfileUser',
    // '/ChangePasswrod',
    // '/main/ChangePasswrod',
    // '/FileArchive',
    // '/main/FileArchive',
    // '/SendFileArchive',
    // '/main/SendFileArchive',
  ];

  const callback = useCallback(
    () =>
      Get(
        `${process.env.REACT_APP_API_URL_API_GET_MAINPAGE_CONFIG}`,
        false,
        {}
      ).then((res) => {
        if (res.data.resCode === 1) {
          setAppConfig(res.data.Data);
        } else {
          SwalAlert('warning', res.data.resMessage, false);
        }
      }),
    []
  );
  React.useLayoutEffect(() => {
    callback();
  }, []);

  const idPatient = Cookies.get('user')
    ? JSON.parse(Cookies.get('user'))?.IdPatient
    : false;
  useEffect(() => {
    if (idPatient) {
      Post(
        'POST',
        `${process.env.REACT_APP_API_URL_API_HAVE_PERMISSION_FOR_SAVE_NOBAT}`,
        true,
        {
          idPatient,
        }
      ).then((res) => {
        setIsTurnAllowed(res.data.Data);
      });
    }
  }, [idPatient]);

  const GlobalConstants = {
    navigate,
    user,
    uuidV4,
    setDrawerOpen,
    IsDrawerOpen,
    IdPerson,
    AccessRoles,
    UserInformation,
    EntirePageRender,
    setEntirePageRender,
    MoreColumns,
    setMoreColumns,
    changeRender,
    setChangeRender,
    LanguageArray: LangList,
    rootPaths: rootPaths ? rootPaths : [],
    roles,
    setIsTokeValid,
    appConfig,
    settingDrawerOpen,
    setSettingDrawerOpen,
    roles,
    isTurnAllowed,
  };

  return (
    <GlobalContext.Provider value={GlobalConstants}>
      {children}
    </GlobalContext.Provider>
  );
};
